import service from './api.services';
// Definindo a URL base do serviço
const BASE_URL = '/api/documento'; // Altere conforme a sua configuração

const listarTiposDocumentos = async () => {
    const response = await service.get(`${BASE_URL}`);
    return response.data;
};

const listarTiposDocumentosAll = async () => {
    const response = await service.get(`${BASE_URL}/all/relacao`);
    return response.data;
};

const editarTiposDocumentos = async (idDocumento, nomeDocumento, descricaoDocumento, ativoDocumento) => {
    try {
        const response = await service.put(`${BASE_URL}/editar/${idDocumento}`, {
            nome: nomeDocumento,
            descricao: descricaoDocumento,
            ativo: ativoDocumento
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao editar tipo de documento:', error);
        throw error;
    }
};

const deletarTiposDocumentos = async (idDocumento) => {
    try {
        const response = await service.delete(`${BASE_URL}/deletar/${idDocumento}`);
        return response.data; // Pode retornar uma mensagem de sucesso ou o status
    } catch (error) {
        console.error('Erro ao deletar tipo de documento:', error);
        throw error;
    }
};

const criarTipoDocumento = async (nomeDocumento, descricaoDocumento, ativoDocumento) => {
    try {
        const response = await service.post(`${BASE_URL}/criacao`, {
            nome: nomeDocumento,
            descricao: descricaoDocumento,
            ativo: ativoDocumento
        });
        return response.data; // Retorna a resposta do backend
    } catch (error) {
        console.error('Erro ao criar tipo de documento:', error);
        throw error;
    }
};

const downloadDocumentoById = async (idDocumento) => {
    const response = await service.get(`/api/documento/download/${idDocumento}`, {
        responseType: 'blob'
    });
    return response;
};

export {
    listarTiposDocumentos,
    listarTiposDocumentosAll,
    editarTiposDocumentos,
    deletarTiposDocumentos,
    criarTipoDocumento,
    downloadDocumentoById
};
